import { BadgeDifficulty } from '../Gaming/BadgeDifficulty/BadgeDifficulty';
import { Exp } from '../Gaming/Exp/Exp';
import { useGaming } from '../../../contexts/GamingContext';
import { useEffect } from 'react';
import styles from './BadgeUnlockPopup.module.scss';

const BadgeUnlockPopupComponent = () => {
  const { achievementUnlocked, setAchievementUnlocked, nf } = useGaming();

  useEffect(() => {
    if (!achievementUnlocked) return;
    try {
      document.querySelector(`.${styles.circle}`).classList.add(styles.circleAnimate);
      document.querySelector(`.${styles.banner}`).classList.add(styles.bannerAnimate);
      document.querySelector(`.${styles.achieveDisp}`).classList.add(styles.achieveDispAnimate);
      setTimeout(() => {
        try {
          document.querySelector(`.${styles.circle}`).classList.remove(styles.circleAnimate);
          document.querySelector(`.${styles.banner}`).classList.remove(styles.bannerAnimate);
          document.querySelector(`.${styles.achieveDisp}`).classList.remove(styles.achieveDispAnimate);
          setTimeout(() => setAchievementUnlocked(false));
        } catch {}
      }, 11000);
    } catch {}
  }, [achievementUnlocked]);

  if (!achievementUnlocked) return null;

  return (
    <div className={styles.achievement}>
      <div className={styles.animation}>
        <div className={styles.circle}>
          <div className={`${styles.img} ${styles.trophyAnimate} trophy_img`}>
            <img className={styles.trophy1} src={achievementUnlocked.image} />
          </div>
          <div className={`${styles.img} ${styles.xboxImg}`}>
            <img src={process.env.PUBLIC_URL + '/oo-logo-w.png'} />
          </div>
        </div>
        <div className={styles.bannerOuter}>
          <div className={styles.banner}>
            <div className={styles.achieveDisp}>
              <span className={styles.unlocked}>{achievementUnlocked.name}</span>
              <div className={styles.scoreDisp}>
                <div className={styles.gamerscore}>
                  <BadgeDifficulty difficulty={achievementUnlocked.difficulty} className={'small'} />
                  <span className={'mx-2'}> • </span>
                  <div className={'small d-flex align-items-center'}>
                    <Exp className={'mr-1'} />
                    <span>{nf(achievementUnlocked.exp)} EXP</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { BadgeUnlockPopupComponent as BadgeUnlockPopup };
